import styled from 'styled-components';

const StyledIndustriesCarouselMenu = styled.div`
  position: relative;
  margin-top: ${props => props.noMarginTop ? 0 : props.theme.components_spacing_desk.xxlarge}px;
  padding-bottom: ${props => props.noPaddingBottom ? 0 : props.theme.components_spacing_desk.xxlarge}px;
  padding-right: 64px;
  padding-left: 64px;
  .carousel--head{
    display: flex;
    align-item: flex-start;
    justify-content: space-between;
    margin-bottom: 160px;
  }
  .carousel--head h5{
    width: 66.66%;
    flex: 1 0 66.66%;
  }
  .carousel-industries--slider{
    align-items: flex-start;
    padding-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
  }
  .swiper-container{
    position: relative;
    z-index: 2;
  }
  .swiper-button-next,
  .swiper-button-prev {
    z-index: 2;
    transform: translateZ(1px);
  }
  .carousel-industries--slider .swiper-slide{
    width: calc(33.33% - 64px);
    margin-right: 8.33%;
  }
  .carousel-industries--slider .swiper-slide img{
    width: 100%;
  }
  .carousel-industries--slider .swiper-slide p {
    margin-top: 24px;
  }
  @media screen and (max-width: 1439px){
    padding-right: 40px;
    padding-left: 40px;
  }
  @media screen and (max-width: 1023px){
    margin-top: ${props => props.noMarginTop ? 0 : props.theme.components_spacing_tablet.xxlarge}px;
    padding-bottom: ${props => props.noPaddingBottom ? 0 : props.theme.components_spacing_tablet.xxlarge}px;
    .carousel--head{
      margin-bottom: 128px;
    }
    .carousel-industries--slider .swiper-slide{
      width: calc(41.66% - 40px);
      margin-right: 8.33%;
    }
    
    .carousel-industries--slider{
      padding-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    }
  }
  @media screen and (max-width: 767px){
    margin-top: ${props => props.noMarginTop ? 0 : props.theme.components_spacing_mobile.xxlarge}px;
    padding-right: 24px;
    padding-left: 24px;
    padding-bottom: ${props => props.noPaddingBottom ? 0 : props.theme.components_spacing_mobile.xxlarge}px;
    .carousel--head{
      flex-direction: column;
      margin-bottom: 80px;
    }
    .carousel--head h5{
      width: 100%;
      flex: 1 0 100%;
      margin-bottom: 24px;
    }
    .carousel-industries--slider .swiper-slide{
      width: calc(75% - 24px);
      margin-right: 8.33%;
    }
    .carousel-industries--slider{
      padding-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    }
  }
  .swiper-button-next {
    background-image: url(/arrow-next-carousel.svg);
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center;
    width: 64px;
    height: 64px;
    right: 0;
    top: 80px;
    margin: 0;
    background-color: #000;
    border-radius: 50%;
    transition: background-color .25s;
  }
  .swiper-button-disabled{
    display: none;
  }
  
  .swiper-button-next::after {
    display: none;
  }
  .swiper-button-prev {
    background-image: url(/arrow-prev-carousel.svg);
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center;
    width: 64px;
    height: 64px;
    left: 0;
    top: 80px;
    margin: 0;
    background-color: #000;
    border-radius: 50%;
    transition: background-color .25s;
  }
  .swiper-button-prev:hover, .swiper-button-next:hover{
    background-color: ${props => props.theme.colors.green_secondary};
  }
  .swiper-button-prev::after {
    display: none;
  }
  @media screen and (max-width: 1023px){
    top: 40px;
  }
  @media screen and (max-width: 767px){
    .swiper-button-next,
    .swiper-button-prev{
      width: 44px;
      height: 44px;
      padding: 6px;
      top: 24px;
      background-color: transparent;
    }
    .swiper-button-next:hover,
    .swiper-button-prev:hover{
      background-color: transparent;
    }
    .swiper-button-next::after{
      background-image: url(/arrow-next-carousel.svg);
    }
    .swiper-button-prev::after{
      background-image: url(/arrow-prev-carousel.svg);
    }
    .swiper-button-next::after,
    .swiper-button-prev::after {
      content: '';
      display: block;
      border-radius: 50%;
      background-color: #000;
      width: 100%;
      height: 100%;
      
      background-repeat: no-repeat;
      background-size: 100% auto;
      background-position: center;
    }
  }
`;

export {
  StyledIndustriesCarouselMenu,
};

